import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c2ec9ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "email-update",
  class: "center-card with-margin"
}
const _hoisted_2 = { class: "error-message" }

import { computed, ComputedRef, onBeforeMount, onUnmounted, watch } from 'vue'
  import { useRoute, LocationQueryValue, useRouter } from 'vue-router'

  import ErrorImg from '@/components/Common/Images/ErrorImg.vue'
  import { AUTH_USER_STORE, ROOT_STORE } from '@/store/constants'
  import { IAuthUserProfile } from '@/types/user'
  import { useStore } from '@/use/useStore'

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute()
  const router = useRouter()
  const store = useStore()

  const authUser: ComputedRef<IAuthUserProfile> = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.AUTH_USER_PROFILE]
  )
  const isAuthenticated: ComputedRef<boolean> = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.IS_AUTHENTICATED]
  )
  const errorMessages: ComputedRef<string | string[] | null> = computed(
    () => store.getters[ROOT_STORE.GETTERS.ERROR_MESSAGES]
  )
  const token: ComputedRef<LocationQueryValue | LocationQueryValue[]> =
    computed(() => route.query.token)

  onBeforeMount(() => confirmEmail())

  function confirmEmail() {
    if (token.value) {
      store.dispatch(AUTH_USER_STORE.ACTIONS.CONFIRM_EMAIL, {
        token: token.value,
        refreshUser: isAuthenticated.value,
      })
    } else {
      router.push('/')
    }
  }

  onUnmounted(() => store.commit(ROOT_STORE.MUTATIONS.EMPTY_ERROR_MESSAGES))

  watch(
    () => errorMessages.value,
    (newValue) => {
      if (authUser.value.username && newValue) {
        router.push('/')
      }
    }
  )

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_unref(errorMessages) && !_unref(authUser).username)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(ErrorImg),
        _createElementVNode("p", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('error.SOMETHING_WRONG')) + ".", 1),
          _createElementVNode("span", null, [
            _createVNode(_component_i18n_t, { keypath: "user.PROFILE.ERRORED_EMAIL_UPDATE" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: "/login" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('user.LOG_IN')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})